
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';

import Analyze2OpsubResult from './Analyze2OpsubResult';
import SelectOpsubPanel from './SelectOpsubPanel';
import IfComp from '../common/IfComp';

const classNames = mergeStyleSets({
    Analyze2OpsubView: {
        paddingLeft: 16,
        paddingRight: 16
    },
    analyzeButton: {
        //paddingTop: 8
    }
});

const Analyze2OpsubView = ({
    analyzeData,
    analyze2opsubActions,
    canAnalyze,
    isAnalyzeLoading,
    isAnalyzeLoaded,
    isknDateNew,
    isknDateOld,
    project,
    projectKatuzeKod,
    opsubItemNew,
    opsubItemOld,
    opsubItemsNew,
    opsubItemsOld,
    token,
    onClickAnalyze,
    onChangeNew,
    onChangeOld
}) => {

    return (
        <Stack className={classNames.Analyze2OpsubView} verticalFill tokens={{childrenGap: 16}}>
            <Stack.Item grow>
                <Stack horizontal tokens={{childrenGap: 8}}>
                    <Stack.Item>
                        <SelectOpsubPanel
                            title="VÝBĚR PŮVODNÍHO VLASTNÍKA"
                            isknDate={isknDateOld}
                            opsubItem={opsubItemOld}
                            opsubItems={opsubItemsOld}
                            projectId={project.id}
                            projectKatuzeKod={projectKatuzeKod}
                            token={token}
                            getOpsub={analyze2opsubActions.getOpsubOld}
                            onChange={onChangeOld}
                        />
                    </Stack.Item>
                    <Stack.Item>
                        <SelectOpsubPanel
                            title="VÝBĚR NOVÉHO VLASTNÍKA"
                            isknDate={isknDateNew}
                            opsubItem={opsubItemNew}
                            opsubItems={opsubItemsNew}
                            projectId={project.id}
                            projectKatuzeKod={projectKatuzeKod}
                            token={token}
                            getOpsub={analyze2opsubActions.getOpsubNew}
                            onChange={onChangeNew}
                        />
                    </Stack.Item>
                </Stack>
            </Stack.Item>
            <Stack.Item>
                <Stack horizontal>
                    <Stack.Item className={classNames.analyzeButton}>
                        <PrimaryButton
                            disabled={!canAnalyze || isAnalyzeLoading}
                            text="Analyzovat převod mezi vlastníky"
                            onClick={onClickAnalyze}
                        />
                    </Stack.Item>
                </Stack>
            </Stack.Item>
            <Stack.Item>
                <IfComp cond={isAnalyzeLoading || isAnalyzeLoaded}>
                    <Analyze2OpsubResult
                        isLoaded={isAnalyzeLoaded}
                        data={analyzeData}
                    />
                </IfComp>
            </Stack.Item>
        </Stack>
    );
}

export default Analyze2OpsubView;
